import type { components } from '@/api/schema'
import type { ActionItemSource } from '@/features/purchase-orders/action-source'
import type { WarrantyClaimAction } from './api'

type PurchaseOrderAction = NonNullable<components['schemas']['PurchaseOrderDetailRead']['actions']>[number]

/**
 * A warranty item as the PO action cards read one (USA-915): the same fields a PO action has, with the
 * warranty item's own. In progress counts as open, as it does on a PO.
 */
export function toPurchaseOrderAction(action: WarrantyClaimAction): PurchaseOrderAction {
  return {
    id: action.id,
    uuid: action.uuid,
    purchase_order_id: action.purchase_order_id ?? 0,
    line_item_id: null,
    communication_message_id: action.communication_message_id ?? null,
    action_type: action.action_type,
    status: action.status === 'in_progress' ? 'open' : action.status,
    summary: action.summary,
    details: action.details ?? null,
    structured_data: action.structured_data ?? null,
    expected_date: null,
    charge_amount: null,
    assigned_role: action.assigned_role,
    created_by: action.created_by ?? null,
    resolved_by: action.resolved_by ?? null,
    resolved_at: action.resolved_at ?? null,
    resolution_type: action.resolution_type ?? null,
    resolution_data: action.resolution_data ?? null,
    communicated_at: null,
    customer_approval_required: false,
    customer_approval_status: null,
    customer_communication_thread_id: null,
    shipping_communication_thread_id: null,
    customer_draft_subject: null,
    customer_draft_email: null,
    draft_response: action.draft_response ?? null,
    customer_decision: null,
    customer_decision_details: null,
    customer_decision_at: null,
    created_at: action.created_at,
    updated_at: action.updated_at,
    card: action.card ?? null,
    progress: action.progress ?? [],
  }
}

/** Where the cards' resolve, reopen, progress and reply calls go for these warranty items. */
export function warrantySource(
  actionsKey: readonly unknown[],
  rows: readonly { id: number; uuid: string }[],
  poUuid: string | null,
): ActionItemSource {
  return {
    kind: 'warranty_claim',
    actionsKey,
    actionUuids: Object.fromEntries(rows.map((row) => [row.id, row.uuid])),
    poUuid,
  }
}
